<p>Attenzione, per proseguire con questa tipologia di pagamento devi inserire prima i dati del tuo genitore.
</p>

<div style='display: flex; justify-content: space-between'>
  <button mat-button (click)='dismiss(false)'>Annulla</button>
  <button mat-raised-button color='primary' (click)='dismiss(true)' cdkFocusInitial>Inserisci dati</button>
</div>
